export default __webpack_public_path__ + "images/fa71a953ce0560ebed3dcc2b89dd1217-charity_and_causes.webp";